import { HealthCheckEvents, THealthCheckFactory } from "./types/index";
import bind from "bind-decorator";
import Api from "./index";

export default class LogService {
  private static log = console.log;
  private static error = console.error;

  private static _instance: LogService;
  public static get instance(): LogService {
    return this._instance = this._instance || new LogService();
  }

  public static enableEachLogSend() {
    this.instance.enableLogSend();
  }

  private _logsEnabled: boolean = false;

  public enableLogSend() {
    if (this._logsEnabled) {
      return;
    }

    console.log = this.log;
    console.error = this.error;
    window.onerror = this.globalErrorHandler;
    this._logsEnabled = true;
  }

  @bind
  private log(...args: any[]) {
    LogService.log.apply(console, args);
    this.healthCheckFactory(HealthCheckEvents.consoleMessage).sendSuccess(
      JSON.stringify(args)
    );
  }

  @bind
  private error(...args: any[]) {
    LogService.error.apply(console, args);
    this.healthCheckFactory(HealthCheckEvents.consoleError).sendFailure(
      JSON.stringify({ args })
    );
  }

  @bind
  private globalErrorHandler(
    errorMsg: string,
    url: string,
    lineNumber: number
  ) {
    this.healthCheckFactory(HealthCheckEvents.globalError).sendFailure(
      JSON.stringify({ errorMsg, url, lineNumber })
    );
  }

  @bind
  private healthCheckFactory(event: HealthCheckEvents) {
    return Api.healthCheckFor(event);
  }
}
